export default "__VITE_ASSET__onK$3RBA__"